import { render, staticRenderFns } from "./PedidoItem.vue?vue&type=template&id=850dfd10&"
import script from "./PedidoItem.vue?vue&type=script&lang=js&"
export * from "./PedidoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports